import { useEffect, useCallback, useRef } from 'react';

interface InfiniteScrollOptions {
  threshold?: number;
  disabled?: boolean;
}

export function useInfiniteScroll(
  onLoadMore: () => void,
  options: InfiniteScrollOptions = {}
) {
  const { threshold = 100, disabled = false } = options;
  const observerRef = useRef<IntersectionObserver | null>(null);

  const loadMoreRef = useCallback((node: HTMLElement | null) => {
    if (disabled) return;
    
    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    observerRef.current = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          onLoadMore();
        }
      },
      { 
        root: null,
        rootMargin: `${threshold}px`,
        threshold: 0
      }
    );

    if (node) {
      observerRef.current.observe(node);
    }
  }, [onLoadMore, disabled, threshold]);

  useEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return loadMoreRef;
}